export default __webpack_public_path__ + "c9b05c306737a74a12c95c39a4af6b40.jpg";